/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';

import getAxiosInstance from 'utils/getAxiosInstance';
import * as selectConfig from './selectConfig';

export const axiosInstance = createSelector([selectConfig.values], getAxiosInstance);
